"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandingView = void 0;
const PIXI = __importStar(require("pixi.js"));
const module_abstract_1 = require("@kennethgomez/module/module.abstract");
const app_1 = require("@kennethgomez/app");
const star_circle_controller_1 = require("../controllers/star-circle-controller/star-circle-controller");
class LandingView extends module_abstract_1.Module {
    static MAX_CIRCLE_ANIMATION_STEP = 3;
    _leftCircle;
    _topCircle;
    _rightCircle;
    constructor() {
        super([
            new star_circle_controller_1.StarCircleController(),
        ]);
        this._leftCircle = new PIXI.Container();
        this._topCircle = new PIXI.Container();
        this._rightCircle = new PIXI.Container();
    }
    onInit() {
        app_1.App.instance.canvas.space.addChild(this._leftCircle, this._topCircle, this._rightCircle);
    }
    start(stars) {
        this._startLoading(stars);
    }
    _startLoading(stars) {
        const { CIRCLE_SIZE, CIRCLE_OFFSET } = star_circle_controller_1.StarCircleController;
        const [left, top, right] = this.motionController.splitStars(stars.map((s) => s.sprite));
        this._leftCircle.addChild(...left);
        this._topCircle.addChild(...top);
        this._rightCircle.addChild(...right);
        const screenCenterX = window.innerWidth / 2;
        const screenCenterY = window.innerHeight / 2 + CIRCLE_SIZE * 2;
        this.motionController.makeCircle(this._leftCircle, screenCenterX - CIRCLE_OFFSET, screenCenterY);
        this.motionController.makeCircle(this._topCircle, screenCenterX, screenCenterY - CIRCLE_OFFSET * 1.5);
        this.motionController.makeCircle(this._rightCircle, screenCenterX + CIRCLE_OFFSET, screenCenterY)
            ?.on('finish', () => setTimeout(this._moveLoadingCircles.bind(this), 500));
    }
    _moveLoadingCircles(step = 0) {
        const { CIRCLE_OFFSET } = star_circle_controller_1.StarCircleController;
        if (step >= LandingView.MAX_CIRCLE_ANIMATION_STEP) {
            setTimeout(() => {
                this._startLanding();
            }, 250);
            return;
        }
        const size = this.starCircles.length;
        this.motionController.moveCircle(this.starCircles[step % size], CIRCLE_OFFSET, -CIRCLE_OFFSET * 1.5);
        this.motionController.moveCircle(this.starCircles[(step + 1) % size], CIRCLE_OFFSET, CIRCLE_OFFSET * 1.5);
        this.motionController.moveCircle(this.starCircles[(step + 2) % size], -CIRCLE_OFFSET * 2, 0)
            .on('finish', () => setTimeout(() => this._moveLoadingCircles(step + 1), 200));
    }
    _startLanding() {
        const { CIRCLE_OFFSET } = star_circle_controller_1.StarCircleController;
        this.motionController.moveCircle(this._leftCircle, CIRCLE_OFFSET, 0);
        this.motionController.moveCircle(this._rightCircle, -CIRCLE_OFFSET, CIRCLE_OFFSET * 1.5)
            .on('finish', () => setTimeout(this._makeNavigator.bind(this), 250));
    }
    _makeNavigator() {
        const { CIRCLE_OFFSET } = star_circle_controller_1.StarCircleController;
        const target = (window.innerWidth / 2) - CIRCLE_OFFSET * 1.5;
        let animation;
        for (let i = 0; i < this.starCircles.length; i++) {
            const circle = this.starCircles[i];
            animation = this.motionController.moveCircle(circle, target, 0);
        }
        animation?.on('finish', () => setTimeout(this._openNavigator.bind(this), 250));
    }
    _openNavigator() {
        this.motionController.addAnimationToStars(this._topCircle, 'scale', 40, {
            target: 2,
        });
        this.motionController.moveCircle(this._topCircle, 0, -(star_circle_controller_1.StarCircleController.CIRCLE_OFFSET * 2));
    }
    get starCircles() {
        return [
            this._leftCircle,
            this._topCircle,
            this._rightCircle,
        ];
    }
    get motionController() {
        return this.getSubmodule(star_circle_controller_1.StarCircleController);
    }
}
exports.LandingView = LandingView;
